export default __webpack_public_path__ + "static/media/FlagMarker.789d0fd4.svg";